export const userRoute = {
    path: "/user",
    name: "用户数据",
    meta: { title: "用户数据", affix: true },
    component: resolve => require(["@/components/index"], resolve),
    children: [
        {
            path: "start_detail",
            name: "启动数据",
            component: resolve =>
                require(["@/components/user/startDetail"], resolve),
            meta: { title: "启动数据" }
        },
        {
            path: "online_time",
            name: "在线时长",
            component: resolve =>
                require(["@/components/user/onlineTime"], resolve),
            meta: { title: "在线时长" }
        },
        {
            path: "retention",
            name: "新用户留存",
            component: resolve =>
                require(["@/components/user/retention"], resolve),
            meta: { title: "新用户留存" }
        },
        {
            path: "user_from",
            name: "用户来源",
            component: resolve =>
                require(["@/components/user/userFrom"], resolve),
            meta: { title: "用户来源" }
        },
        {
            path: "whole_detail",
            name: "整体趋势详细",
            component: resolve =>
                require(["@/components/user/wholeDetail"], resolve),
            meta: { title: "整体趋势详细" }
        },
        {
            path: "scene",
            name: "场景数据",
            component: resolve =>
                require(["@/components/user/sceneUser"], resolve),
            meta: { title: "场景数据" }
        },
        {
            path: "scene_retention",
            name: "场景用户留存",
            component: resolve =>
                require(["@/components/user/sceneRetention"], resolve),
            meta: { title: "场景用户留存" }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/user.js